module.exports = __webpack_public_path__ + "b864d2959f8bb26aa39c937b799ed9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-in-the-house/Bedroom1.jpg
// module id = 3360
// module chunks = 0